import { render, staticRenderFns } from "./AccionesModalEdicion.vue?vue&type=template&id=542fb4da&scoped=true&"
import script from "./AccionesModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./AccionesModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./AccionesModalEdicion.vue?vue&type=style&index=0&id=542fb4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542fb4da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('542fb4da', component.options)
    } else {
      api.reload('542fb4da', component.options)
    }
    module.hot.accept("./AccionesModalEdicion.vue?vue&type=template&id=542fb4da&scoped=true&", function () {
      api.rerender('542fb4da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mantenedores/AccionesModalEdicion.vue"
export default component.exports